'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _notificationUtils = require('../../../../../../common/notifications/notificationUtils');

require('./ElementCount.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ElementCount = function ElementCount(props) {
    var contentTotalCount = props.contentTotalCount,
        elementCount = props.elementCount,
        contentTotalLimit = props.contentTotalLimit,
        showCountDetail = props.showCountDetail,
        children = props.children;

    var isFull = contentTotalCount >= contentTotalLimit;
    var countDetail = showCountDetail ? (0, _notificationUtils.describeElementTypes)(elementCount.toJS()) : '';

    return _react2.default.createElement(
        'div',
        { className: 'ElementCount' },
        _react2.default.createElement(
            'div',
            { className: 'content-explain' },
            children,
            contentTotalCount,
            ' / ',
            contentTotalLimit,
            ' used',
            countDetail.length ? ' (' + countDetail + ')' : null
        ),
        _react2.default.createElement('progress', { value: contentTotalCount, max: contentTotalLimit, className: (0, _classnames2.default)({ full: isFull }) })
    );
};

ElementCount.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array, _propTypes2.default.string]),
    elementCount: _propTypes2.default.object,
    contentTotalCount: _propTypes2.default.number,
    contentTotalLimit: _propTypes2.default.number,
    showCountDetail: _propTypes2.default.bool
};

exports.default = ElementCount;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/billingStatus/ElementCount.js
// module id = 774
// module chunks = 0